// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-37YN7","type_review":"type_review-lfZcs","confirmed":"confirmed-sUJIr","icon":"icon-24mFF"};